import React, { Component, Fragment } from 'react'
import { Breadcrumb, Button, Card, Popconfirm, Row, Steps } from 'antd'
import style from '../../../../../components/Finance/style.css'
import TransactionUploadForm from '../../../../../components/Finance/Statements/Transactions/TransactionsUpload/TransactionUploadForm'
import TransactionsCompareList from '../../../../../components/Finance/Statements/Transactions/TransactionsUpload/TransactionsCompareList'

const Step = Steps.Step

class TransactionsUpload extends Component {
  render() {
    const { current, prev, next, submit, submitting, fetching, transactionUploadFormRef } = this.props
    const steps = [
      {
        title: 'Select File',
        key: 'Select File',
        content: <TransactionUploadForm ref={transactionUploadFormRef} {...this.props} />,
      },
      {
        title: 'Compare and Upload',
        key: 'Compare and Upload',
        content: <TransactionsCompareList {...this.props} />,
      },
    ]
    return (
      <Fragment>
        <Card>
          <Row className={style.pageHeader}>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Finance</Breadcrumb.Item>
              <Breadcrumb.Item href="#/finance/statements/#transactions">Transactions</Breadcrumb.Item>
              <Breadcrumb.Item>Upload Transactions</Breadcrumb.Item>
            </Breadcrumb>
            <h2 className={style.title}>Upload Transactions</h2>
            <p className={style.paragraph}>Upload and compare with existing system transactions.</p>
          </Row>
        </Card>
        <Card className={style.contentCard}>
          <Steps current={current}>
            {steps.map((item) => (
              <Step key={item.key} title={item.title} />
            ))}
          </Steps>
          <div className="steps-action" style={{ textAlign: 'center', paddingTop: 20 }}>
            {current > 0 && (
              <Button style={{ marginRight: 8 }} onClick={() => prev()}>
                Previous
              </Button>
            )}
            {current < steps.length - 1 && (
              <Button style={{ width: '100px' }} type="primary" loading={fetching} onClick={() => next()}>
                Next
              </Button>
            )}
            {current === steps.length - 1 && (
              <Popconfirm title="Sure to submit?" onConfirm={() => submit()}>
                <Button loading={submitting} type="primary">
                  Submit
                </Button>
              </Popconfirm>
            )}
          </div>
          <div style={{ marginTop: '50px', marginBottom: '10px' }} className="steps-content">
            {steps[current].content}
          </div>
        </Card>
      </Fragment>
    )
  }
}

TransactionsUpload.propTypes = {}
TransactionsUpload.defaultProps = {}

export default TransactionsUpload
